import {
  Stepper as BaseStepper,
  styled,
  Grid as GridBase,
  StepLabel as BaseStepLabel,
} from "@mui/material";

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: ${(props) => props.margin || "0"};
    gap: ${(props) => props.spacing || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const AcquirerFormRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const Stepper = styled(BaseStepper)(({ theme }) => ({
  backgroundColor: theme.palette.blokko.taglineMist,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 4),
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2, 2),
  },
}));

export const StepLabel = styled((props) => <BaseStepLabel {...props} />)`
  color: ${(props) => props.color || "text.secondary"};
  font-weight: ${(props) => props.fontWeight || "normal"};
`;
